import React, { useState } from "react";
import { Form } from "antd";
import Draggable from "react-draggable";
import { CloseOutlined } from "@ant-design/icons";
import { Modal, Button, Typography, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import CheckBoxItem from "../../../components/forms/CheckBoxItem";
import AnimationChildWrapper from "../../../components/animations/AnimationChildWrapper";
import ChildrenAnimationWrapper from "../../../components/animations/ChildrenAnimationWrapper";
import { useIntl } from "react-intl";
import { exportEmergency } from "../PatientsSlice";
import { openURL } from "../../../components/util/helpers";

const { Title } = Typography;
const ExportEmergencyModal = (props) => {
  const { onHide, visible, branchId } = props;
  const [disabled, setDisabled] = useState(true);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const loading = useSelector(
    (state) => state.pendingActions["patients/exportEmergency"]
  );
  const intl = useIntl();

  const onCancel = () => {
    onHide();
    form.resetFields();
  };

  const onMouseOver = () => {
    setDisabled(false);
  };

  const onMouseOut = () => {
    setDisabled(true);
  };

  const onFinish = async (values) => {
    const data = {
      params: {
        incremental: values.incremental,
      },
      branchId,
    };
    const action = await dispatch(exportEmergency(data));
    if (!action.error) {
      onHide();
      form.resetFields();
      openURL(action.payload.data.file_url);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const layout = {
    labelCol: { span: 9 },
    wrapperCol: { span: 15 },
  };

  return (
    <Modal
      closable={false}
      footer={null}
      maskClosable={false}
      title={null}
      width={"600px"}
      styles={{
        body: {
          padding: 0,
        },
      }}
      open={visible}
      modalRender={(modal) => (
        <Draggable disabled={disabled}>{modal}</Draggable>
      )}
      forceRender
    >
      <div>
        <div
          style={{
            width: "100%",
            cursor: "move",
            height: "50px",
            position: "absolute",
            left: "0",
            top: "0",
          }}
          className="header"
          onMouseOver={onMouseOver}
          onMouseOut={onMouseOut}
        >
          <Button
            style={{ position: "absolute", left: 10, top: 10 }}
            className="closeBtn"
            type="text"
            shape="circle"
            icon={<CloseOutlined />}
            onClick={onCancel}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "40px 40px 40px 40px",
          }}
        >
          <Title
            style={{
              fontSize: "30px",
              fontWeight: 500,
              lineHeight: 1.27,
              color: "rgba(0, 0, 0, 0.85)",
              margin: "13px 0 40px 0 ",
              textAlign: "center",
            }}
          >
            {intl.formatMessage({
              id: "app.patients.emergency_export",
            })}
          </Title>
          <div
            style={{ display: "flex", flexDirection: "column", width: "300px" }}
          >
            <Form
              {...layout}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              form={form}
            >
              <ChildrenAnimationWrapper>
                <Row>
                  <div style={{ flex: 1 }}>
                    <AnimationChildWrapper itemKey={1}>
                      <CheckBoxItem
                        showLabel={true}
                        name="incremental"
                        category="component"
                      />
                    </AnimationChildWrapper>

                    <AnimationChildWrapper itemKey={4}>
                      <div
                        style={{
                          alignItems: "center",
                          justifyContent: "center",
                          display: "flex",
                        }}
                      >
                        <Button
                          htmlType="submit"
                          style={{ marginTop: "20px" }}
                          type="primary"
                          loading={loading}
                        >
                          {intl.formatMessage({
                            id: "app.actions.export",
                          })}
                        </Button>
                      </div>
                    </AnimationChildWrapper>
                  </div>
                </Row>
              </ChildrenAnimationWrapper>
            </Form>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ExportEmergencyModal;
